import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MobilePhoneValidator } from './only-mobile.validator';

@NgModule({
  declarations: [MobilePhoneValidator],
  imports: [CommonModule],
  exports: [MobilePhoneValidator],
})
export class ValidatorsModule {}
